__turbopack_context__.v({
  "blink": "index-module-scss-module__LYtp7a__blink",
  "card": "index-module-scss-module__LYtp7a__card",
  "cardIcon": "index-module-scss-module__LYtp7a__cardIcon",
  "cardName": "index-module-scss-module__LYtp7a__cardName",
  "cardSelected": "index-module-scss-module__LYtp7a__cardSelected",
  "cardSub": "index-module-scss-module__LYtp7a__cardSub",
  "checkBadge": "index-module-scss-module__LYtp7a__checkBadge",
  "grid": "index-module-scss-module__LYtp7a__grid",
  "switching": "index-module-scss-module__LYtp7a__switching",
});
